import { isEmptyTiptap } from "@/util/tiptap.js";
import { MEETING_POINT_INSTRUCTION_KEY, MEETING_POINT_KEYS } from "./constants";

export const hasMeetingPointData = (data) => {
  return MEETING_POINT_KEYS.some((key) => {
    const val = data?.[key];
    return key === MEETING_POINT_INSTRUCTION_KEY ? !isEmptyTiptap(val) : !!val;
  });
};
